<template>
  <footer class="footer footer-alt fw-medium">
    <span class="text-dark">
      {{ CurrentYear }} ©
      <a
        href="https://jciindia.in"
        target="_blank"
        class="text-dark-75 text-hover-primary"
        >JCI India</a
      >
      - Powered by
      <a
        href="http://vaagai.org.in"
        target="_blank"
        class="text-dark-75 text-hover-primary"
        >Vaagai Tecknowledge</a
      >
    </span>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      CurrentYear: new Date().getFullYear(),
    };
  },
};
</script>

